import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class KeysManagerFailedToCreatePartnerKeysError extends BaseEitherError {}

export type TKeysManagerCreatePartnerKeysOperationErrors =
  KeysManagerFailedToCreatePartnerKeysError;
